import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import cartReducer from "../ReduxToolkit/cartSlice"
import authReducer from "./authSlice";
import collectionReducer from "./collectionSlice";
import productReducer from "./productSlice";
import orderReducer from "./orderSlice";

import rootSaga from "./sagas/rootSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    auth: authReducer,
    collections: collectionReducer,
    products: productReducer,
    order: orderReducer,
    cart: cartReducer,

  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);

export default store;